import React from 'react'
import { Link, useParams } from 'react-router-dom'
import Vimeo from '@u-wave/react-vimeo';
import { useEffect, useState, useContext, useRef } from 'react';
import './collections.css'
import apiClient from '../../helpers/axiosHelper';
import { AuthContext } from '../../context/Authcontext'
import { ModalVideos } from '../feedback/modal/ModalVideos';
import { smoothScrollUp } from '../../helpers/scrollHelper';
import { LoadingComponent } from '../common/LoadingComponent/LoadingComponent';
import { HtmlViewer } from '../htmlViewer/HtmlViewer'

export const Collections = () => {


  useEffect(() => {
    document.title = 'TPA® Oficial - Videos'
  }, [])

  const [libreryVideosData, setLibreryVideosData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [videoToWatch, setVideoToWatch] = useState(null)
  const [isHidden, setIsHidden] = useState(false)
  const { logout } = useContext(AuthContext)
  const [libreryName, setLibreryName] = useState('')

  const watchTimeoutRef = useRef(null);

  // 👉Efecto para ocultar/mostrar info del video
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0 && !isHidden) {
        setIsHidden(true)
      } else if (window.pageYOffset === 0 && isHidden) {
        setIsHidden(false)
      }
    };

    window.addEventListener('scroll', handleScroll)


    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isHidden])




  const { collectionId } = useParams()
  //console.log('collectionId: ', collectionId)



  const findFirstVideo = (array) => {

    //👉 Encuentra el menor valor de "order"
    const smallestOrder = Math.min(...array.map(video => video.order))

    // //👉 Encuentra el objeto
    // const firstVideoWithSmallestOrder = array.find(video => video.order === smallestOrder) 

    return smallestOrder
  }



  const videoPlay = () => {


  }


  const videoEnd = () => {
    if (libreryVideosData) {

      const newOrder = videoToWatch.order + 1

      if (newOrder > libreryVideosData.length) {
        //👉Volver al primer video despues del ultimo en la coleccion

        changeVideoToWatch(libreryVideosData, findFirstVideo(libreryVideosData))
      } else {
        changeVideoToWatch(libreryVideosData, newOrder)
      }

      // Cambia al siguiente video

    }
  }



  //👉 Cambia el video a reproducir
  const changeVideoToWatch = (data, order) => {
    //console.log('data: ', data)
    const findOrder = data.find(video => video.order === order)
    setVideoToWatch(findOrder)
    //console.log('FindOrder: ', findOrder)

    return findOrder
  }


  useEffect(() => {
    const fetchLibrery = async () => {
      try {

        const response = await apiClient.get(`Library/GetVideos/${collectionId}`)
        //console.log('response.Library: ', response)


        if (response) {
          setLibreryVideosData(response.data.videos)

          setLoading(false);

        }


        if (response.data) {

          //console.log('response.data.videos: ',response.data.videos)
          const WatchedVideo = response.data.videos.find(video => video.selected === true)

          //console.log('El video visto fue: ', WatchedVideo)

          if (WatchedVideo) {
            setVideoToWatch(WatchedVideo)
          } else {
            setVideoToWatch(changeVideoToWatch(response.data.videos, findFirstVideo(response.data.videos)))
          }


          setLibreryName(response.data.name)
        }



      } catch (error) {

        logout()
        //console.log('collections error es: ', error)
        setLoading(false)
      }
    }

    fetchLibrery()
  }, [collectionId, logout])

  
  useEffect(() => {
  // Limpiar el timeout anterior si el video cambia antes de los X segundos
  if (watchTimeoutRef.current) {
    clearTimeout(watchTimeoutRef.current);
  }

  // Configurar nuevo timeout
  if (collectionId && videoToWatch) {

    watchTimeoutRef.current = setTimeout(async () => {
      try {
        const body = {
          libraryExternalReference: `${collectionId}`,
          videoExternalReference: videoToWatch.externalReference,
          videoId: videoToWatch.id
        };

        await apiClient.put(`Video/WatchVideo`, body);
        console.log(`Video ${videoToWatch.externalReference} marcado como visto`);
      } catch (error) {
        console.error(error);
      }
    }, 15000); // ⏱️ Espera 15 segundos
  }

  // Cleanup
  return () => {
    if (watchTimeoutRef.current) {
      clearTimeout(watchTimeoutRef.current);
    }
  };
}, [collectionId, videoToWatch]);



  useEffect(() => {
    //👉 La pagina carga mostrandose desde el comienzo
    window.scrollTo(0, 0)
  }, [])



  //👉 "isSmallSreen" devuelve True o False
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 800)

  useEffect(() => {
    // console.log('isSmallScreen: ', isSmallScreen)
  }, [isSmallScreen])


  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 800)
    }

    //👉 Escucha los cambios de tamaño de la ventana
    window.addEventListener('resize', handleResize)

    //👉 Limpia el listener cuando el componente se desmonta
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])



  const [showModal, setshowModal] = useState(false)

  const toggleModal = () => {
    setshowModal(!showModal)
  }


  return (
    <>

      {loading
        ?
        <LoadingComponent />
        :
        <div className="main-container mc-padding">


          <ul className="breadcrumb">

            <Link to="/biblioteca"><i className="bi bi-collection bi-class-colecction-empty"></i>Bibliotecas</Link>

            <li className="arrow">/</li>
            <li>{libreryName && libreryName}</li>
          </ul>

          <div className="player-container">

            <div className={isHidden ? "video-player vPlayer-margin" : "video-player"}>

              {videoToWatch &&
                // <>
                // <iframe 
                //   src={`https://player.vimeo.com/video/${videoToWatch.externalReference}?autoplay=1&muted=1`}
                //   frameBorder="0"
                //   allow="autoplay; fullscreen; picture-in-picture"
                //   allowFullScreen                                    
                // ></iframe>
                // <script src="https://player.vimeo.com/api/player.js"></script>
                // </>

                <Vimeo
                  video={videoToWatch.externalReference}
                  muted={true}
                  // video={318092091}
                  autoplay={true}
                  onPlay={videoPlay}
                  onEnd={videoEnd}
                  speed={true}
                />
              }                
            </div>


            <div className={`${isHidden ? 'info-video-container oculto' : 'info-video-container'}`}
              onClick={() => {
                if (isSmallScreen) {
                  toggleModal()
                }
              }}>

              <h2>{videoToWatch && videoToWatch.name}</h2>

              <hr className="hr-line hrl-style" />

              <div className="description-container" >
                <p className="description-video">
                      <span>{videoToWatch && videoToWatch.description && videoToWatch.description?.indexOf("%3C") < 0 ? videoToWatch.description : null}</span>
                      {videoToWatch && videoToWatch.description && videoToWatch.description?.indexOf("%3C") >= 0 ? <HtmlViewer content={decodeURIComponent(videoToWatch.description)}></HtmlViewer> : null}
                </p>
                {videoToWatch && videoToWatch.description ? <span className="span-ver-mas">mas</span> : null}
              </div>


            </div>

          </div>

          {videoToWatch && <ModalVideos showModal={showModal} toggleModal={toggleModal} info={videoToWatch.name && videoToWatch.name} description={videoToWatch.description && videoToWatch.description} />}

          <div className='box-container'>


            {libreryVideosData && libreryVideosData.length > 0 ? libreryVideosData.map((l) => (

              <Link key={l.id} href=""
                onClick={() => {
                  // fetchVideoWatch(l.externalReference);
                  changeVideoToWatch(libreryVideosData, l.order);

                  if (!isSmallScreen) {
                    // smoothScrollUp()
                    const container = document.getElementsByClassName('cont-secundario')[0];
                    container.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    });
                  }

                }
                }>

                <div className={l.order === videoToWatch.order ? "box video-box-style selected " : "box video-box-style "}>

                  <div className="img-container">
                    <i className="bi bi-play-circle bi-class-play "></i>
                    <img className="box-img"
                      src={l.pictureUrl}
                      alt={l.name} />
                  </div>

                  <div className="description description-style">
                    <div className="h2-container">
                      <h2 className="h2-style">{l.name}</h2>
                    </div>

                  </div>

                </div>
              </Link>
            )) : null}

          </div>

        </div>
      }



    </>


  )
}
